import DeleteFaq from './DeleteFaq'
export default DeleteFaq